import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import { useReactToPrint } from "react-to-print";
import { Box } from "@mui/material";
import { useMyHrEmployee } from "my-hr/hooks";
import {
  MyTimesheetMyRequestsDashboard,
  MyTimesheetMyRequestsDashboardPrint,
  MyTimesheetPageTitle,
} from "my-timesheet/components";
import {
  useMyTimesheetDashboardDate,
  useMyTimesheetTimesheetList,
} from "my-timesheet/hooks";
import { PeriodType } from "my-timesheet/types/period-type";
import { OcPageTransition } from "oc/components";
import { useOcCurrentUserState } from "oc/hooks";
import { useOcIsMobile } from "oc/hooks/use-is-mobile";
import { getFullname } from "oc/utils";

export const MyTimesheetMyRequestsDashboardPage = () => {
  const { t } = useTranslation();
  const isMobile = useOcIsMobile();
  const componentRef = useRef(null);

  const {
    currentDate,
    period,
    handlePeriodChange,
    handleChangeCurrentDate,
    periodStart,
    periodEnd,
  } = useMyTimesheetDashboardDate("myRequestsDashboard");

  let { contractCode, employeeCode } = useOcCurrentUserState();
  const { data: employeeData } = useMyHrEmployee({ employeeId: employeeCode });

  const { hoursSummary, extendedData } = useMyTimesheetTimesheetList({
    contractId: contractCode,
    periodStart: periodStart,
    periodEnd: periodEnd,
    dashboard: true,
    role: "user",
  });

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  return (
    <OcPageTransition>
      <Box padding="16px">
        <Box>
          <MyTimesheetPageTitle
            title={t("MY_TIMESHEET_SUMMARY")}
            showDateRange={true}
            currentDate={currentDate}
            handleChangeCurrentDate={handleChangeCurrentDate}
            period={
              period === "week" || period === "month" ? period : undefined
            }
            handlePeriodChange={(period) =>
              handlePeriodChange(period as PeriodType)
            }
            isMobile={isMobile}
          />
        </Box>
        <Box height="16px" />
        <MyTimesheetMyRequestsDashboard
          periodStart={periodStart.toISOString()}
          periodEnd={periodEnd.toISOString()}
          isMobile={isMobile}
          onPrint={handlePrint}
        />
      </Box>
      <Box style={{ display: "none" }}>
        <MyTimesheetMyRequestsDashboardPrint
          ref={componentRef}
          periodStart={periodStart.toISOString()}
          employeeName={getFullname(employeeData) ?? ""}
          contractCode={contractCode}
          hoursSummary={hoursSummary}
          dailyEntries={extendedData || []}
        />
      </Box>
    </OcPageTransition>
  );
};

export default MyTimesheetMyRequestsDashboardPage;
